import { defineMessages } from 'react-intl'

const scope = `procurify.components.TaxForm`

export default defineMessages({
  nameRequiredError: {
    id: `${scope}.nameRequiredError`,
    defaultMessage: 'Tax name is required',
  },
  nameFieldPlaceholder: {
    id: `${scope}.nameFieldPlaceholder`,
    defaultMessage: 'i.e. VAT, GST',
  },
  nameFieldLabel: {
    id: `${scope}.nameFieldLabel`,
    defaultMessage: 'Tax name',
  },
  submitButtonLabel: {
    id: `${scope}.submitButtonLabel`,
    defaultMessage: 'Add tax rate',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  taxRateRequiredError: {
    id: `${scope}.taxRateRequiredError`,
    defaultMessage: 'Tax rate is required',
  },
  modalTitleDeprecated: {
    id: `${scope}.modalTitleDeprecated`,
    defaultMessage: 'Create Tax',
  },
  taxRateLabel: {
    id: `${scope}.taxRateLabel`,
    defaultMessage: 'Tax rate %',
  },
  taxRatePlaceholder: {
    id: `${scope}.taxRatePlaceholder`,
    defaultMessage: 'Input rate %',
  },
  inclusiveTaxLabel: {
    id: `${scope}.inclusiveTaxLabel`,
    defaultMessage: 'Inclusive tax',
  },
  descriptionPlaceholder: {
    id: `${scope}.descriptionPlaceholder`,
    defaultMessage: 'What is this tax code for?',
  },
  descriptionLabel: {
    id: `${scope}.descriptionLabel`,
    defaultMessage: 'Description',
  },
  modalHeader: {
    id: `${scope}.modalHeader`,
    defaultMessage: 'Add tax rate',
  },
  inclusiveTaxTooltipMessage: {
    id: `${scope}.inclusiveTaxTooltipMessage`,
    defaultMessage: 'Tax is included in the total cost per item on bills',
  },
  inclusiveTaxTooltipLabel: {
    id: `${scope}.inclusiveTaxTooltipLabel`,
    defaultMessage: 'Inclusive tax tooltip',
  },
})
